<template>
    <div v-if="qrCodeDataUrl"
         class="qr-code">
        <img :width="width"
             :src="qrCodeDataUrl" />
    </div>
</template>

<script>
import QRCode from 'qrcode';

export default {
    props: {
        content: {
            type: String,
            required: true,
        },

        width: {
            type: Number,
            default: 300,
        },

        options: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            defaults: {
                errorCorrectionLevel: 'M',
                width: this.width,
                color: {
                    dark: '#000000',
                    light: '#ffffff',
                },
            },
            qrCodeDataUrl: null,
        };
    },

    watch: {
        // Regenerate the QR code whenever the value prop changes.
        content: {
            immediate: true,
            async handler(newValue) {
                await this.generateQrCode(newValue);
            },
        },
    },

    methods: {
        async generateQrCode(text) {
            try {
                // await is required although the IDE may not think so.
                this.qrCodeDataUrl = await QRCode.toDataURL(text, this.defaults);
            } catch (err) {
                console.error('Failed to generate QR code:', err);
                this.qrCodeDataUrl = null;
            }
        },
    },
};
</script>

<style lang="less">
.qr-code {
    margin: auto;
    max-width: 100%;
}
</style>
